import type { FC, ReactElement } from 'react';

import {
  StyledAccessBanner,
  StyledBannerBtnWrapper,
  StyledBannerContent,
  StyledBannerContentDescription,
  StyledBannerContentTitle,
  StyledIconWrapper,
} from './styles';

type GrandAccessBanner = {
  title?: string;
  description: string;
  button: ReactElement;
  iconImagePath: string;
};

// Banner for upsell/grand access special for blocked users
export const GrandAccessBanner: FC<GrandAccessBanner> = ({ title, description, iconImagePath, button }) => {
  return (
    <StyledAccessBanner>
      <StyledIconWrapper>
        <img src={iconImagePath} />
      </StyledIconWrapper>
      <StyledBannerContent>
        {title ? <StyledBannerContentTitle>{title}</StyledBannerContentTitle> : null}
        <StyledBannerContentDescription>{description}</StyledBannerContentDescription>
        <StyledBannerBtnWrapper>{button}</StyledBannerBtnWrapper>
      </StyledBannerContent>
    </StyledAccessBanner>
  );
};
